import "./style.css";
import inView from "in-view";

export default class Hero {
  static selector = ".s-banner";

  constructor(block) {
    this.block = block;
    this.index = this.block.getAttribute("data-instance-index");
  }

  onEnterView() {
    this.block.classList.add("in-view");
  }

  onExitView() {
    this.block.classList.remove("in-view");
  }

  onReady() {
    const inViewClassName = `.s-banner[data-instance-index="${this.index}"]`;

    inView.threshold(0.5);
    inView(inViewClassName).on("enter", this.onEnterView.bind(this));
    inView(inViewClassName).on("exit", this.onExitView.bind(this));
  }
}
